import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

function getSessionId() {
  let sid = sessionStorage.getItem("_corsa_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("_corsa_sid", sid);
  }
  return sid;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    api.post("/track", {
      path: location.pathname,
      session_id: getSessionId(),
    }).catch(() => {});
  }, [location.pathname]);
}
